//@ts-ignore
import oldColors from 'platform-components/src/design/colors.scss';
//@ts-ignore
import uiKitColors from 'platform-components/src/design/ui-kit-colors.scss';

const colors = Object.assign(oldColors, uiKitColors);
export default colors;
